import {
  GET_N_PILOT_MEASUREMENTS_FAILED,
  GET_N_PILOT_MEASUREMENTS_LOADING,
  GET_N_PILOT_MEASUREMENTS_SUCCESS,
  STATUS_DEFAULT,
} from 'Redux/actions/types';

export const initialNPilotMeasurementState = {
  status: STATUS_DEFAULT,
  data: [],
  errorCode: null,
};

export default (state = initialNPilotMeasurementState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_N_PILOT_MEASUREMENTS_LOADING:
      return {
        ...state,
        data: payload,
        status: GET_N_PILOT_MEASUREMENTS_LOADING,
      };
    case GET_N_PILOT_MEASUREMENTS_SUCCESS:
      return {
        status: GET_N_PILOT_MEASUREMENTS_SUCCESS,
        data: payload,
        errorCode: null,
      };
    case GET_N_PILOT_MEASUREMENTS_FAILED:
      return {
        ...state,
        status: GET_N_PILOT_MEASUREMENTS_FAILED,
        errorCode: payload.errorCode,
      };
    default:
      return state;
  }
};
